import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69dab6aaa749570014e96d4d_1788938710275_ada6f20f/shipmanmacleod/src/app/fr/gift/page.tsx");
